import React from "react";
import styles from "./perennialmandalism.module.css";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";
import SignUpModal from "../../components/Modal/SignUpModal";
import ComingSoonModal from "../../components/Modal/ComingSoonModal";

import PerrenialMandalismBlock from "../../components/PerrenialMandalismBlock/PerrenialMandalismBlock";
import Link from "next/link";
import { useRouter } from "next/router";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [newOpen, setNewOpen] = useState(false);

  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);

  const router = useRouter();


  // payment

  const [signUpModalState, setSignUpModalState] = useState(false);
  const [copyRightOpen, setCopyRightOpen] = useState(false);

  const perrenialData = [
    {
      mainHeading: "Creed of the Eternal Path",
      mainDescription:
        "We, the seekers of the Eternal Path, embrace the sacred teachings of the Bhagavad Gita. These timeless principles guide us towards a life of righteousness, wisdom, and divine devotion. We strive to embody these truths in our daily lives, cultivating inner peace and spiritual harmony.",
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/Creed_of_the_Eternal_Path_1new.webp",
      contentWithPoints: [
        {
          title: "1. The Law of Duty (Dharma)",
          description:
            "We dedicate ourselves to fulfilling our sacred duties with integrity and devotion. Each role and responsibility we undertake is performed as an offering to the divine, without attachment to personal gain.",
          point:
            '"Perform your obligatory duty, because action is indeed better than inaction." (Bhagavad Gita 3:8)',
        },
        {
          title: "2. The Path of Selfless Action (Karma Yoga)",
          description:
            "We embrace the path of Karma Yoga, engaging in selfless actions without attachment to their outcomes. Our deeds are driven by a sense of duty and the well-being of others, free from personal desires.",
          point:
            '"You have the right to perform your prescribed duties, but you are not entitled to the fruits of your actions." (Bhagavad Gita 2:47)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/The_Pursuit_of_Wisdom_Jnana_Yoga.webp",
      contentWithPoints: [
        {
          title: "3. The Pursuit of Wisdom (Jnana Yoga)",
          description:
            "We seek true knowledge and wisdom, recognizing that our essence transcends the physical form. Through introspection and study, we endeavor to understand the deeper spiritual truths of our existence.",
          point:
            '"Just as a lamp in a windless place does not flicker, so is a yogi, who controls their mind, remains steady in meditation on the self." (Bhagavad Gita 6:19)',
        },
        {
          title: "4. The Devotion to the Divine (Bhakti Yoga)",
          description:
            "We cultivate a profound devotion to the Divine, fostering a personal and loving relationship with the Supreme. Through prayer, worship, and surrender, we open our hearts to divine grace and guidance.",
          point:
            '"Fix your mind on Me, be devoted to Me, worship Me, and offer obeisance to Me. Thus you will come to Me; I promise you this truth, for you are very dear to Me." (Bhagavad Gita 18:65)',
        },
        {
          title: " 5. The Spirit of Renunciation (Sannyasa)",
          description:
            "We renounce attachment to material possessions and the ego, recognizing the fleeting nature of worldly desires. By surrendering our personal ambitions, we align ourselves with the eternal and find true freedom.",
          point:
            '"The truly renounced soul neither longs for nor rejects anything. Such a person is free from dualities and is easily liberated from material bondage." (Bhagavad Gita 5:3)',
        },
      ],
    },

    // -------------------rajdeep-------------------

    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/the_practice_of_equinimity_img.webp",
      contentWithPoints: [
        {
          title: "6. The Practice of Equanimity",
          description:
            "We strive to maintain equanimity in the face of life’s dualities. Whether in joy or sorrow, success or failure, we remain balanced and serene, guided by inner peace and spiritual wisdom.",
          point:
            '"One who remains unmoved by circumstances, unaffected by joy and sorrow, and views all beings with equanimity, attains supreme peace." (Bhagavad Gita 6:7)',
        },
        {
          title: "7. The Principle of Detachment",
          description:
            "We practice detachment from the fruits of our actions and worldly desires, understanding that true peace comes from within. This detachment frees us from the bondage of outcomes and fosters inner tranquility.",
          point:
            '"He who performs his duty without attachment, surrendering the results to the Supreme Lord, is unaffected by sinful action, as the lotus leaf is untouched by water." (Bhagavad Gita 5:10)',
        },
        {
          title: "8. The Virtue of Faith and Surrender",
          description:
            "We uphold unwavering faith in the Divine and surrender to the Supreme's will. Trusting in divine wisdom and grace, we find strength and serenity in all aspects of our lives.",
          point:
            '"Abandon all varieties of religion and just surrender unto Me. I shall deliver you from all sinful reactions; do not fear." (Bhagavad Gita 18:66)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/the_discipline_of_self_control_img.webp",
      contentWithPoints: [
        {
          title: "9. The Discipline of Self-Control",
          description:
            "We cultivate self-discipline, mastering our senses and mind to achieve clarity and strength. Through disciplined living, we attain harmony within ourselves and with the world around us.",
          point:
            '"One must elevate, not degrade, oneself by one’s own mind. The mind alone is one’s friend as well as one’s enemy" (Bhagavad Gita 6:5)',
        },
        {
          title: "10. The Ethic of Compassion and Non-Violence",
          description:
            "We uphold the sacred principles of compassion and non-violence, recognizing the divine presence in every being. We commit to treating all life forms with love, kindness, and respect, fostering harmony and understanding in our interactions and communities.",
          point:
            '"One is dear to Me who is free from malice towards others, who is friendly and compassionate, who is free from egoism and selfishness, and who is patient in suffering." (Bhagavad Gita 12:13)',
        },
      ],
    },
    {
      mainHeading: "The Creed of Initiation",
      mainDescription:
        "We, the initiates of the Shakta Path, embrace the sacred mysteries of the Goddess. These divine rites guide us into the heart of Shakti, where we awaken to the hidden truths of existence. Through this creed, we commit to the transformative journey of initiation, opening ourselves to the Goddess's boundless power and wisdom.",
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/the_creed_of_initiation_img.webp",
      contentWithPoints: [
        {
          title: "1. The Call to Awakening (Prabodha)",
          description:
            "We heed the Goddess's call to awaken from the sleep of ignorance. By stepping into Her mysteries, we cross the threshold into a realm where the ordinary dissolves, and the secrets of the cosmos begin to unfold.",
          point:
            '"Only through awakening can one perceive Her, the One who dances at the heart of creation." (Tripura Sundari Tantra)',
        },
        {
          title: "2. The Rite of Inner Transformation (Antar Yajna)",
          description:
            "We engage in the sacred rites that transform the inner self, preparing us for the mysteries to come. Through ritual, meditation, and the cultivation of inner fire, we cleanse ourselves, becoming vessels worthy of the Goddess's grace.",
          point:
            '"In the inner sacrifice, the self is offered to the Self; only then does the light of the Goddess shine forth." (Kali Tantra)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/lord_shiva_img.webp",
      contentWithPoints: [
        {
          title: "3. The Descent into the Unknown (Avidya-Marga) ",
          description:
            "We embrace the path of the unknown, willingly descending into the darkness of our own ignorance. It is within this sacred darkness that the Goddess reveals Her hidden face, guiding us through the labyrinth of our minds.",
          point:
            '"She is the dark womb of all creation; only in the darkness does the light of wisdom dawn." (Yogini Hridaya Tantra)',
        },
        {
          title: "4. The Union with the Goddess (Samyoga)",
          description:
            "We seek union with the Goddess, recognizing initiation as an intimate embrace of the Divine Feminine. Through mantra, yantra, and sacred dance, we merge with Her essence, awakening the divine within us.",
          point:
            '"In union with the Goddess, the initiate transcends all dualities, entering the space beyond time and form." (Rudra Yamala Tantra)',
        },
        {
          title: "5. The Passage through the Veils (Chakra Bheda)",
          description:
            "We journey through the sacred centers of energy, piercing the veils of illusion. Each veil we pass is a step deeper into the mysteries of Shakti, guiding us to the core of Her power.",
          point:
            '"The chakras are the gateways to Her mysteries; only by piercing them does one reach the abode of the Goddess." (Shiva Swarodaya)',
        },
      ],
    },

    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/shakti_vidya_img.webp",
      contentWithPoints: [
        {
          title: "6. The Reception of the Sacred Knowledge (Shakti Vidya)",
          description:
            "We open ourselves to the sacred knowledge bestowed by the Goddess, realizing that true initiation lies in receiving Her teachings directly. This wisdom cannot be grasped by intellect alone but must be absorbed through experience and devotion.",
          point:
            '"The Goddess whispers Her knowledge into the heart of the initiate, revealing the secrets of existence." (Devi Rahasya)',
        },
        {
          title: "7. The Alchemy of the Soul (Atma-Rasa)",
          description:
            "We undergo the alchemy of the soul, where the base elements of our nature are transformed into the pure gold of spiritual insight. The Goddess is both the alchemist and the elixir, transmuting our essence into divine consciousness.",
          point:
            '"By Her touch, the soul is turned to gold, and the initiate becomes an embodiment of Her radiance." (Kaulajnana Nirnaya)',
        },
        {
          title: "8. The Embrace of Divine Power (Shakti-Pata)",
          description:
            "We accept the descent of the Goddess's power, allowing Her energy to surge through us. In this initiation, we become bearers of Her force, learning to channel and direct Her currents toward the liberation of all beings.",
          point:
            '"The power of the Goddess descends upon the initiate like lightning, awakening the dormant divinity within. " (Tantraraja Tantra)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/hridaya_nishabda_img.webp",
      contentWithPoints: [
        {
          title: "9. The Silence of the Heart (Hridaya Nisshabda)",
          description:
            "We learn to enter the silence of the heart, where the Goddess reveals Her most profound mysteries. In this inner stillness, beyond words and thought, we come face to face with the ineffable nature of the Divine.",
          point:
            '"In the silence of the heart, She speaks, and the initiate learns the language of the eternal." (Devi Upanishad)',
        },
        {
          title: "10. The Ascent into the Infinite (Ananta Udaya)",
          description:
            "We ascend into the infinite, where the boundaries of self dissolve, and we merge with the cosmic expanse of the Goddess. This final initiation is the realization of our unity with Shakti, the embodiment of all that is.",
          point:
            '"The Goddess lifts the initiate beyond the finite; there, one becomes the infinite itself." (Shakti Sangama Tantra)',
        },
      ],
    },
    {
      mainHeading: "Creed of the Living Light",
      mainDescription:
        "We, the followers of the Living Light, embrace the wisdom imparted in the Gospel of Thomas. These sayings of the Master guide us to seek the truth within, to understand our divine nature, and to live in unity with all creation.",
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/meditating_budhha_img.webp",
      contentWithPoints: [
        {
          title: "1. The light Within",
          description:
            "We believe that the Kingdom of God is within and among us. We seek the divine light within ourselves and in every being, understanding that true enlightenment comes from recognizing our inner divinity.",
          point:
            '"The Kingdom is inside of you, and it is outside of you. When you come to know yourselves, then you will become known, and you will realize that you are the children of the living Father." (Saying 3)',
        },
        {
          title: "2. The search for Knowledge",
          description:
            "We commit to the pursuit of inner knowledge and wisdom. We understand that knowing ourselves is key to knowing the divine. We strive to awaken and perceive the deeper truths of our existence.",
          point:
            '"He who seeks shall find, and he who knocks, it shall be opened to him." (Saying 94)',
        },
      ],
    },

    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/the_path_of_simplycity_img.webp",
      contentWithPoints: [
        {
          title: "3. The path of Simplicity",
          description:
            "We live simply and humbly, valuing spiritual wealth over material possessions. We recognize that simplicity in life and purity of heart lead to greater clarity and connection with the divine.",
          point:
            '"If you do not fast from the world, you will not find the Kingdom." (Saying 27)',
        },
        {
          title: "4. The Unity of all",
          description:
            "We honor the interconnectedness of all creation. We see the divine presence in every person and thing, fostering unity and compassion among all beings.",
          point:
            '"I am the light that is over all things. I am all: from me all came forth, and to me all attained." (Saying 77)',
        },
        {
          title: "5. The Embrace of Paradox",
          description:
            "We accept the paradoxes and mysteries of life, finding wisdom in the seemingly contradictory. We understand that spiritual truths often lie beyond conventional understanding.",
          point:
            '"If you bring forth what is within you, what you bring forth will save you. If you do not bring forth what is within you, what you do not bring forth will destroy you." (Saying 70)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/the_practice_of_silence_img.webp",
      contentWithPoints: [
        {
          title: "6. The Practice of Silence",
          description:
            "We value silence and stillness as pathways to deeper understanding and connection with the divine. In the quiet, we listen for the voice of wisdom and the guidance of the Spirit.",
          point: '"Be passersby." (Saying 42)',
        },
        {
          title: "7. The Pursuit of Truth",
          description:
            "We commit to seeking and living in truth, even when it challenges us. We acknowledge that the journey to truth is ongoing and requires courage and openness. mindfulness.",
          point:
            '"The one who seeks should not cease seeking until he finds. And when he finds, he will be troubled. And if he is troubled, he will be astonished, and he will rule over all."  (Saying 2)',
        },
        {
          title: "8. The Transcendence of Opposites",
          description:
            "We transcend dualities and opposites, recognizing the unity underlying all apparent differences. We see beyond the surface and embrace the oneness of all.",
          point:
            '"When you make the two into one, and when you make the inner like the outer and the outer like the inner... then you will enter the Kingdom."  (Saying 22)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/the_joy_of_presence_img.webp",
      contentWithPoints: [
        {
          title: "9. The Joy of Presence",
          description:
            "We cultivate joy and gratitude in the present moment, understanding that the divine is found here and now. We live with mindfulness and appreciation for the gift of life.",
          point:
            '"The Father\'s Kingdom is spread out upon the earth, and men do not see it" (Saying 113)',
        },
        {
          title: "10. The light of Gtuidance and Love of Others",
          description:
            "We follow the teachings of the Master as a guiding light on our spiritual journey. We aspire to live with love, wisdom, and compassion, embodying the divine principles in all our actions towards ourselves and others.",
          point:
            "\"Jesus said, 'Love your brother like your soul, guard him like the pupil of your eye.' \" (Saying 25)",
        },
      ],
    },

    // -------------------rajdeep-------------------

    // -------------------souvik-------------------
    {
      mainHeading: "Creed of the Way and Virtue",
      mainDescription:
        "We, the followers of the Way and Virtue, embrace the timeless wisdom of the Tao Te Ching. Guided by the principles of Taoism, we seek to live in harmony with the natural order, cultivate inner peace, and embody simplicity and humility in all our actions.",
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/Creed_of_the_Way_and_Virtue.webp",
      contentWithPoints: [
        {
          title: "1. The Harmony with the Tao",
          description:
            "We align our lives with the Tao, the fundamental way and natural order of the universe. By flowing with the Tao, we find balance, peace, and fulfillment, allowing life to unfold effortlessly and harmoniously.",
          point:
            '"The Dao that can be told is not the eternal Dao; the name that can be named is not the eternal name." (Tao Te Ching, Chapter 1)',
        },
        {
          title: "2. The Practice of Non-Action (Wu Wei)",
          description:
            "We embrace the principle of Wu Wei, or non-action, which means acting in accordance with the natural flow and without unnecessary force. We achieve more by doing less, letting go of struggle and effort, and allowing things to take their natural course.",
          point:
            '"By non-action, there is nothing that cannot be done." (Tao Te Ching, Chapter 48)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/The_Value_of_Simplicity.webp",
      contentWithPoints: [
        {
          title: "3. The Value of Simplicity",
          description:
            "We live simply and humbly, finding contentment in less and appreciating the small joys of life. By reducing our desires and focusing on what truly matters, we achieve greater clarity and tranquility.",
          point:
            '"I have three treasures, guard and keep them: the first is deep love, the second is frugality, and the third is not to dare to be ahead of others." (Tao Te Ching, Chapter 67)',
        },
        {
          title: "4. The Balance of Opposites",
          description:
            "We honor the balance of opposites, understanding that harmony arises from the interplay of yin and yang, light and dark, strength and softness. We seek to balance these forces within ourselves and in our interactions with the world.",
          point:
            '"Know the male, yet keep to the female; become a ravine to all under heaven. By being a ravine to all under heaven, eternal virtue will never desert you." (Tao Te Ching, Chapter 28)',
        },
        {
          title: "5. The Embrace of Spontaneity",
          description:
            "We value spontaneity and naturalness, recognizing that the most profound actions and insights often arise spontaneously, without premeditation. We trust in the flow of life and allow ourselves to act authentically and effortlessly.",
          point:
            '"When the sage does nothing, nothing is left undone." (Tao Te Ching, Chapter 37)',
        },
      ],
    },

    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/The_Cultivation_of_Inner_Peace_new.webp",
      contentWithPoints: [
        {
          title: "6. The Cultivation of Inner Peace",
          description:
            "We cultivate inner peace and stillness, knowing that true tranquility comes from within. Through meditation, reflection, and mindfulness, we connect with the deeper currents of the Dao and find serenity amidst life’s changes.",
          point:
            '"Returning is the motion of the Dao. Yielding is the way of the Dao." Tao Te Ching, Chapter 40)',
        },
        {
          title: "7. The Strength of Gentleness",
          description:
            "We embrace gentleness and flexibility, understanding that true strength lies in being adaptable and yielding. By being like water, which flows around obstacles and nourishes all things, we achieve resilience and influence without force.",
          point:
            '"Know the male, yet keep to the female; become a ravine to all under heaven. By being a ravine to all under heaven, eternal virtue will never desert you." (Tao Te Ching, Chapter 28)',
        },
        {
          title: "8. The Practice of Compassion",
          description:
            "We live with compassion and kindness, treating all beings with respect and understanding. We extend our care to others without seeking recognition, embodying the virtues of humility and benevolence.",
          point:
            '"The sage has no fixed heart-mind. They make the hearts and minds of the people their own. The sage is good to people who are good. They are also good to people who are not good. This is true goodness." Tao Te Ching, Chapter 49)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/The_Wisdom_of_Not_Knowing.webp",
      contentWithPoints: [
        {
          title: "9. The Wisdom of Not-Knowing",
          description:
            "We embrace the wisdom of not-knowing, recognizing that humility and openness lead to greater understanding. By acknowledging the limits of our knowledge, we remain curious, open to learning, and free from the arrogance of certainty.",
          point:
            '"To know that you do not know is the best. To pretend to know when you do not know is a disease." (Tao Te Ching, Chapter 71)',
        },
        {
          title: "10. The Virtue of Letting Go",
          description:
            "We practice the virtue of letting go, releasing attachments and expectations. By embracing impermanence and allowing things to be as they are, we find freedom and joy in the present moment.",
          point:
            '"When I let go of what I am, I become what I might be." (Tao Te Ching, Chapter 48)',
        },
      ],
    },
    {
      mainHeading: "Creed of Theurgic Rights",
      mainDescription:
        "We, the followers of the Theurgic Rights, dedicate ourselves to the sacred wisdom and divine practices revealed through the teachings of Iamblichus. Guided by the principles of divine philosophy and the art of theurgy, we seek to elevate our souls and align with the divine order of the cosmos.",
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/Creed_of_the_Theurgic_Rights.webp",
      contentWithPoints: [
        {
          title: "1. The Pursuit of Divine Wisdom",
          description:
            "We commit to the pursuit of divine wisdom, understanding that true knowledge transcends the material world. We seek to know the One, the source of all, and strive for the illumination that comes from aligning our intellect with the divine.",
          point:
            '"The intellect, being the eye of the soul, is what connects us to the divine and leads us to the highest truths." (De Mysteriis, Book I, Section 3)',
        },
        {
          title: "2. The Practice of Theurgy",
          description:
            "We engage in theurgy, the sacred rites that invoke the presence and power of the gods. Through these divine rituals, we seek to purify our souls, ascend spiritually, and establish a direct connection with the divine realms.",
          point:
            '"Theurgy binds the divine and the human together, through which we can ascend to the gods and the gods descend to us." (De Mysteriis, Book II, Section 11)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/The_Ascent_of_the_Soul.webp",
      contentWithPoints: [
        {
          title: "3. The Ascent of the Soul",
          description:
            "We believe in the ascent of the soul towards the divine. Our spiritual journey is a process of awakening and returning to our true, immortal nature, guided by the light of divine wisdom and the practice of virtuous living.",
          point:
            '"The soul’s ascent to the divine is the highest form of worship and the ultimate purpose of human existence." (De Mysteriis, Book III, Section 14)',
        },
        {
          title: "4. The Unity of All Being",
          description:
            "We recognize the interconnectedness of all existence, understanding that everything is an expression of the One. We see unity in diversity and strive to perceive the divine essence in all beings and forms.",
          point:
            '"The universe is a living entity, and all its parts are interconnected, deriving their existence from the One." (De Mysteriis, Book IV, Section 9)',
        },
        {
          title: "5. The Harmony of the Cosmos",
          description:
            "We align our lives with the harmony and order of the cosmos, knowing that living in accordance with the natural and divine laws brings peace and fulfillment. We strive to embody the balance and beauty inherent in the cosmic order.",
          point:
            '"The cosmos is an expression of divine order and harmony, reflecting the perfect unity of the One." (De Mysteriis, Book V, Section 7)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/The_Transformation_through_Virtue.webp",
      contentWithPoints: [
        {
          title: "6. The Transformation through Virtue",
          description:
            "We pursue a life of virtue, recognizing that moral excellence is essential for spiritual transformation. Through cultivating virtues like wisdom, courage, and temperance, we purify our souls and prepare for higher spiritual experiences.",
          point:
            '"Virtue is the foundation of the soul’s ascent, purifying and preparing it for union with the divine." (De Mysteriis, Book VI, Section 12)',
        },
        {
          title: "7. The Mystery of the Divine Presence",
          description:
            "We honor the mystery of the divine presence in all rituals and daily life. We approach the sacred with reverence, seeking to deepen our relationship with the divine through continual devotion and mindfulness.",
          point:
            '"In the presence of the divine, the soul is uplifted and transformed, encountering the sacred mysteries of existence." (De Mysteriis, Book VII, Section 19)',
        },
        {
          title: "8. The Light of Inner Illumination",
          description:
            "We seek the light of inner illumination, understanding that true knowledge and wisdom come from within. By turning inward and reflecting on our divine nature, we awaken to the eternal truths that reside in our souls.",
          point:
            '"The light of the soul is its connection to the divine, illuminating the path to truth and wisdom." (De Mysteriis, Book VIII, Section 4)',
        },
      ],
    },
    {
      blockImg:
        "https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/The_Role_of_Divine_Intermediaries.webp",
      contentWithPoints: [
        {
          title: "9. The Role of Divine Intermediaries",
          description:
            "We acknowledge the role of divine intermediaries, such as angels, daimons, and deities, in guiding and assisting us on our spiritual journey. We honor these sacred beings and seek their aid in our quest for divine knowledge and union.",
          point:
            '"The gods, through their intermediaries, guide and support us in our journey towards the divine, bridging the mortal and the immortal." (De Mysteriis, Book IX, Section 3)',
        },
        {
          title: "10. The Embodiment of the Divine Order",
          description:
            "We strive to embody the divine order in our actions, thoughts, and interactions. By living in harmony with the principles of divine philosophy, we become vessels of the divine will, contributing to the greater good of all creation.",
          point:
            '"To live in accordance with the divine order is to become a reflection of the divine, manifesting its will and wisdom in the world." (De Mysteriis, Book X, Section 6)',
        },
      ],
    },
  ];

  return (
    <>
      <Head>
        <title>Perennial Mandalism | School of Our Divine Infinite Being</title>
        <meta
          name="description"
          content="Discover the ancient practice of Perennial Mandalism within the Divine Infinite Being project. Learn about its history, symbolism, and spiritual significance."
        ></meta>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="pentagram, ritual, divine, magic, occult, ceremony"
        ></meta>

        <meta
          property="og:title"
          content="Perennial Mandalism | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:description"
          content="Discover the ancient practice of Perennial Mandalism within the Divine Infinite Being project. Learn about its history, symbolism, and spiritual significance."
        ></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/perennial-mandalism"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/perennial_mandalism_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="A collage of influential figures in philosophy, science, and spirituality"
        ></meta>

        <meta property="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:title"
          content="Perennial Mandalism | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="twitter:description"
          content="Discover the ancient practice of Perennial Mandalism within the Divine Infinite Being project. Learn about its history, symbolism, and spiritual significance."
        ></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/perennial_mandalism_og_img.webp"
        ></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/perennial-mandalism"></meta>
        <meta
          property="twitter:image:alt"
          content="Explore the rich tapestry of intellectual and spiritual influences at the School of Divine Infinite Being"
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/perennial-mandalism" />

      </Head>

      <div className={styles.perennial_mandalism_main}>
        <div className={styles.perennial_mandalism_blockone}>
          {/* {/ <!------Main Banner section-------> /} */}
          <div className={styles.perennial_mandalism_banner_main_wrpr}>
            <div className={styles.perennial_mandalism_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                  />
                </span>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${styles.perennial_mandalism_bottombannerbg} ${styles.bannerboxtxt}`}
              >
                <div className={styles.yellow_bar}></div>
              </div>
            </div>
          </div>
        </div>

        <MysteryBannerNew/>

        <div className={styles.block1_main_wrpr}>
          <div className={styles.common_width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
            >
              <div className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>Perennial Mandalism</h1>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.full_block_wrapper}>
            <div className={styles.blck_sec_common_width}>
              <div className={styles.perennial_mandalism_main_body}>
                <div className={styles.block1_full_width}>
                  <div className={styles.perennial_mandalism_box_wrpr}>
                    <div className={styles.img_box}>
                      {/* <img className={styles.block1_part1_img} src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/perennial_mandalism/perennial_mandalism_blck1_img.webp'/> */}
                      <img
                        className={styles.block1_part1_img}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/perennial_mandalism_blck1_nw_img.webp"
                      ></img>
                      <div
                        className={
                          styles.perennial_mandalism_sign_up_button_container
                        }
                      >
                        {/* <button onClick={()=>setSignUpModalState(true)} className={styles.perennial_mandalism_sign_up_button}>Join our Perennial Mandalin Community</button> */}
                        <Link
                          href="/perennial-signup"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.perennial_mandalism_sign_up_button}
                        >
                          Join our Perennial Mandalin Community
                        </Link>
                      </div>
                    </div>
                    <div className={styles.perennial_mandalism_text_box}>
                      <div className={styles.perennial_mandalism_text_box_bfr}>
                        <h2>
                          We are followers of Krishna, Christ and the Platonic
                          One
                        </h2>

                        <p>We are keepers of the Tao, the way of nature</p>

                        <p>
                          Centrally we exist in Union with our Divine Infinite
                          Being, the Totality State of Existence
                        </p>

                        <p>
                          <span>
                            Our Symbol the Spherical Mandala of Wholeness
                          </span>
                        </p>

                        <p>
                          We invoke the Gods, Goddesses, and the divine natures
                          of existence through the Wheel of Astrology and Tarot,
                          holding a wealth of symbolic archetypal knowledge from
                          deep antiquity, through to the various manifestations
                          of culture emanating into the material world of form
                          over time.
                        </p>

                        <p>
                          We hold sacred the seasons in their turning, the moon
                          in its cycles and the Solar Atman, the jeweled crown
                          of heaven, a reflection of the Archetype of the Self.
                          Our Star in the body of the Cosmic Goddess, Infinite
                          Space.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className={styles.parannial_new_18Aug_main_wrp}> */}
                <div className={styles.parannial_new_18Aug_main_wrp_New}>
                  <div className={styles.parannial_new_18Aug_main_sub_wrp}>
                    <p>As Perennial Mandalins, we honor astrology together as friends and family within a community of like-minded individuals. Our foundation is the practice of astrology alongside the Mandalin Five-Fold Creed.</p>

                    <Button className={styles.parannial_new_18Aug_main_Btn} onClick={() => router.push("/astrology-community")}>Explore the Astrology Community</Button>
                  </div>

                </div>
                {/* </div> */}

                <div className={styles.block2_full_width}>
                  <div className={styles.perennial_mandalism_box_wrpr2}>
                    <div className={styles.img_box}>
                      <img
                        className={styles.block2_part1_img}
                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/perennial_mandalism_blck2_img.webp"
                      />
                      <div
                        className={
                          styles.perennial_mandalism_sign_up_button_container
                        }
                      >
                        {/* <button
                          onClick={() => setSignUpModalState(true)}
                          className={styles.perennial_mandalism_sign_up_button}
                        >
                          Join our Perennial Mandalin Community
                        </button> */}

                        <Link
                          href="/perennial-signup"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.perennial_mandalism_sign_up_button}
                        >
                          Join our Perennial Mandalin Community
                        </Link>
                      </div>
                    </div>
                    <div className={styles.perennial_mandalism_text_box}>
                      <div className={styles.perennial_mandalism_text_box_bfr}>
                        <p>
                          We are keepers of the Anima Mundi, the Soul of the
                          world, holding sacred her presence as the holy spirit,
                          guiding us in the ways of the inseparable divine
                          parent, our Eternal Father and Cosmic Mother in one.
                        </p>

                        <p>
                          We venerate the spiritual scriptures and practices of
                          all religions and people as equal, centrally turning
                          to the holy guidance of Krisha through the{" "}
                          <span>
                            Bhagavad-gita, Christ through the Gospel of Thomas,
                            and the way of nature through the Tao Te Ching.
                          </span>
                        </p>

                        <p>
                          We are a modern spiritual practice embracing the
                          scientific world view as written in our Central
                          Doctrine through quantum mechanics, string theory and
                          the depth fields of psychology.{" "}
                        </p>
                        <p>
                          We are committed to following the pretense of the Five
                          Fold Creed in our daily lives and invite others to
                          learn of our ways whenever we are offered the
                          opportunity.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.block2_new_heading_sec}>
          <div className={styles.blck_sec_common_width}>
            <div className={styles.blck2_heading_sec_wrpr}>
              <div className={styles.left_img_sec}>
                <img src="/image/perennial-mandalism/five_fold_creed_img.webp" alt="Image"></img>
              </div>
              <div className={styles.right_cont_sec}>
                <h4>The Five Fold Creed oF</h4>
                <h2>the Perennial</h2>
                <h1>Mandalan</h1>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.part2_block_sec_main}>
          <div className={styles.blck_sec_common_width}>
            {/* <div className={styles.heading_green_bar}>
                    <h1>The Five Fold Creed on the Perennial Mandalan</h1>
                </div> */}

            <PerrenialMandalismBlock
              data={perrenialData}
              signUpModalState={signUpModalState}
              setSignUpModalState={setSignUpModalState}
            />
          </div>
        </div>


        <div className={styles.parannial_new_18Aug_main_wrp}>
          <div className={styles.blck_sec_common_width}>
            <div className={styles.parannial_new_18Aug_main_sub_wrp}>
              <p>As Perennial Mandalins, we honor astrology together as friends and family within a community of like-minded individuals. Our foundation is the practice of astrology alongside the Mandalin Five-Fold Creed.</p>

              <Button className={styles.parannial_new_18Aug_main_Btn} onClick={() => router.push("/astrology-community")}>Explore the Astrology Community</Button>
            </div>

          </div>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main"
        >
          <Box className="banner_modal_box">
            <Typography
              id="modal-modal-description"
              component="div"
              sx={{ mt: 2 }}
              className="modal_banner"
            >
              <div className="sub_modal_banner">
                <span className="close_btn" onClick={handleClose}>
                  <CloseIcon />
                </span>
                <img
                  src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/logobanner.webp"
                  alt="bannerLogo"
                />
              </div>
            </Typography>
          </Box>
        </Modal>

        <Modal
          open={newOpen}
          onClose={handleNewClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main"
        >
          <Box className="banner_modal_box_new">
            <Typography
              id="modal-modal-description"
              component="div"
              sx={{ mt: 2 }}
              className="modal_banner_new"
            >
              <div className="sub_modal_banner">
                <span className="close_btn" onClick={handleNewClose}>
                  <CloseIcon />
                </span>
                <img
                  src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/logobanner.webp"
                  alt="bannerLogo"
                />
                <p className="modal_commingsoon">Coming soon</p>
              </div>
            </Typography>
          </Box>
        </Modal>

        <SignUpModal
          signUpModalState={signUpModalState}
          setSignUpModalState={setSignUpModalState}
        />

        <ComingSoonModal
          copyRightOpen={copyRightOpen}
          setCopyRightOpen={setCopyRightOpen}
        />
      </div>
    </>
  );
}

export default Index;
